<template>
    <div class="input-wrap" :class="{ border_light: isBorderlight, hover_bg: isHoverBg, highlighted: isBorderlight && isFocused }" :style="`width:${width}px;`">
        <input type="text" @input.stop="inputHander" @focus.stop="focusHandler" @blur.stop="blurHandler" :placeholder="placeText" maxlength="50" v-model="searchKey" @keyup.enter.stop="searchSteamGame" />
        <div class="trails">
            <div :class="{ 'search-clear-icon': true, show_icon: searchKey.length > 0 }" @click="clearContent"></div>
            <div v-show="searchKey.length > 0" class="space_line"></div>
            <div class="search-icon" @click="searchSteamGame"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'search-input',
    data() {
        return {
            searchKey: '',
            isFocused: false
        }
    },
    props: {
        isBorderlight: {
            type: Boolean,
            default: false
        },
        isHoverBg: {
            type: Boolean,
            default: false
        },
        placeText: {
            type: String,
            default: '搜索'
        },
        width: {
            type: Number,
            default: 274
        },
        emptyCanSearch: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        // 搜索
        searchSteamGame() {
            const words = this.searchKey.trim()
            if (words || (!words && this.emptyCanSearch)) {
                this.$emit('searchClick', words)
            }
        },
        clearContent() {
            this.searchKey = ''
            this.$emit('clear')
        },
        focusHandler() {
            if ($('.dialog-mask').length) { // 有弹窗 为了解决edge自动填充触发
                return;
            }
            this.isFocused = true
            const words = this.searchKey.trim()
            this.$emit('focus', words)
        },
        blurHandler() {
            this.isFocused = false
        },
        inputHander() {
            if ($('.dialog-mask').length) { // 有弹窗 为了解决edge自动填充触发
                return;
            }

            const words = this.searchKey.trim()
            this.$emit('input', words)
        }
    }
}
</script>
<style lang="less" scoped>
.input-wrap {
    display: flex;
    align-items: center;
    background: @bg-color-1E;
    position: relative;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;

    .border_light {
        border: 1px solid rgba(0, 0, 0, 0);
    }

    &.highlighted {
        border: 1px solid #00e95b;
    }

    &.hover_bg {
        &:hover {
            background: rgba(255, 255, 255, 0.1);
        }
    }

    input {
        flex: 1;
        height: 100%;
        outline: none;
        border: none;
        padding: 0 70px 0 20px;
        background: 0;
        color: #fff;

        &::-webkit-input-placeholder {
            color: @color-txt-normal;
            font-size: @font-size-normal;
        }
    }

    .trails {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 70px;
        padding-right: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .search-clear-icon {
            visibility: hidden;
            cursor: pointer;
            width: 11px;
            height: 11px;
            background: url(../../assets/ic_x.png) center/100% no-repeat;
        }

        .show_icon {
            visibility: visible;
        }

        .space_line {
            width: 1px;
            height: 12px;
            background-color: #333;
            margin: 0 8px;
        }

        .search-icon {
            cursor: pointer;
            width: 14px;
            height: 14px;
            background: url(../../assets/ic_search.png) center/100% no-repeat;
        }
    }
}
</style>
